import { contentAPI } from '../config';

const getDataOptions = (body) => {
	let cookies;
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	if (typeof window !== 'undefined' && document.cookie) {
		cookies = document.cookie.split(';').reduce((acc, cookie) => {
			const [key, value] = cookie.split('=').map((section) => section.trim());
			return { ...acc, [key]: value };
		}, {});
	}

	const previewCode = cookies ? cookies.previewCode : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers = {
			'api-authorization': process.env.API,
		};
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').filter((part) => !!part).map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${contentAPI}${path}`, getDataOptions(body)).then((data) => data.text()).then((resp) => console.log('DEBUG: resp', resp)).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body))
		.then((resp) => resp.text())
		.then((data) => {
			if (data.slice(0, 1) !== '<') return JSON.parse(data);
			console.log('DEBUG: data', data);
			return data;
		}).catch((err) => console.log(`DEBUG: was not able to be fetched ${contentAPI}${encodedPath}`, err));
};

export { fetchData };
